import React from 'react';
import moment from 'moment';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import theme from './theme';
import Main from './Main';

import './assets/styles/App.css';


const locale = moment.updateLocale('en', {
    week : {
        dow : 1,
    },
});

const App = () => (
    <ThemeProvider theme={theme}>
        <ConfigProvider locale={locale}>
            <Main />
        </ConfigProvider>
    </ThemeProvider>
);

export default App;
